import { render, staticRenderFns } from "./ComponentsListFronts.vue?vue&type=template&id=421e41eb&scoped=true&"
import script from "./ComponentsListFronts.vue?vue&type=script&lang=ts&"
export * from "./ComponentsListFronts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e41eb",
  null
  
)

export default component.exports